import { z, ZodType } from 'zod';
import { Highroller, highrollerSchema } from './highroller';

export type Top = {
	currency: string;
	highrollers: Highroller[];
};

export const topSchema: ZodType<Top> = z.object({
	currency: z.string(),
	highrollers: highrollerSchema.array(),
});
